<template>
  <el-dialog append-to-body width="440px" :visible.sync="dialogVisible">
    <div class="record-box">
      <div class="record-text">
        已申请发售权限
      </div>
      <div class="record-text">
        关注公众号实时接收审核通知
      </div>
      <img src="../../assets/imgs/dp-public.jpg" alt="" class="record-img">
      <div class="record-text">
        微信公众号：DPSpace
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    show () {
      this.dialogVisible = true
    },
    hide () {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .record-box{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction:column;
    box-sizing: border-box;
    padding: 20px;
  }
  .record-img{
    width: 100px;
    height: 100px;
    margin-bottom: 20px;
  }
  .record-text{
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 20px;
    color: #fff;
  }
</style>